<template>
	<div>
		<div>
			<headbar title="全部功能" index="0"></headbar>
		</div>
		<div class="main">
			<van-grid column-num="3" :square="true">
				<van-grid-item
					v-for="(item, i) in functionList"
					:key="i"
					:icon="item.icon"
					:text="item.text"
					@click="goFunction(item.text)"
				>
					<div class="grid_item">
						<div class="grid_img">
							<van-image
								:src="item.icon"
								width="3rem"
								height="3rem"
							/>
						</div>
						<div class="item_p">{{ item.text }}</div>
					</div>
				</van-grid-item>
			</van-grid>
		</div>
	</div>
</template>

<script>
import headbar from '../components/headbar.vue'
export default {
	name: 'Home',
	components: {
		headbar,
	},
	data() {
		return {
			functionList: [
				// { icon: require('@/image/home_1@2x.png'), text: '唯真直播' },
				// { icon: require('@/image/home_2@2x.png'), text: '最新视频' },
				// { icon: require('@/image/home_3@2x.png'), text: '全部老师' },
				// { icon: require('@/image/home_12@2x.png'), text: '实时盯盘' },
				{ icon: require('@/image/home_4@2x.png'), text: '精品课程' },
				// { icon: require('@/image/home_4@2x.png'), text: '精品课程' },
				// { icon: require('@/image/home_7@2x.png'), text: '我的群聊' },
				{ icon: require('@/image/home_9@2x.png'), text: '研报中心' },
				{ icon: require('@/image/home_10@2x.png'), text: '热股排行' },
				// { icon: require('@/image/home_13@2x.png'), text: '新股日历' },
				{ icon: require('@/image/home_11@2x.png'), text: '个人中心' },
			],
		}
	},
	mounted() {},
	methods: {
		goFunction(name) {
			let nowDevice = localStorage.getItem('device')
			if (name == '唯真直播') {
				this.judge('1', 1)
			} else if (name == '最新视频') {
				this.judge('2')
			} else if (name == '全部老师') {
				this.judge('3')
			} else if (name == '实时盯盘') {
				this.$router.push('/realTimeStare')
			} else if (name == '精品课程') {
				this.judge('5')
			} else if (name == '精品节目') {
				this.judge('4')
			} else if (name == '我的群聊') {
				this.judge('6')
			} else if (name == '研报中心') {
				if (nowDevice == 'ios') {
					this.$router.push('/researchReport')
				} else if (nowDevice == 'android' || nowDevice == 'ard' || nowDevice == 'pad') {
					window.android.jsCallAndroidArgs(
						`{jump_type: 14, jump_url: 'http://testmini.weizhenweb.cn/#/researchReport'}`
					)
				} else {
					this.$router.push('/researchReport')
				}
			} else if (name == '热股排行') {
				this.$router.push('/hotStock')
			} else if (name == '个人中心') {
				this.judge('7')
			} else if (name == '新股日历') {
				this.$router.push('/newCalendar')
			}
		},
		judge(type, url) {
			let nowDevice = localStorage.getItem('device')
			if (nowDevice == 'ios') {
				window.webkit.messageHandlers.jsToOcWithPrams.postMessage({
					jump_type: type,
					jump_url: '',
				})
			} else if (nowDevice == 'android' || nowDevice == 'ard' || nowDevice === "pad") {
				window.android.jsCallAndroidArgs(
					`{jump_type: ${type}, jump_url: ${url}}`
				)
			} else if (nowDevice == 'wxmini') {
				wx.miniProgram.postMessage({
					data: {
						jump_type: type,
						jump_url: '',
					},
				})
				wx.miniProgram.navigateBack()
			}
		},
	},
}
</script>

<style>
.grid_img {
	text-align: center;
}
.item_p {
	font-size: 0.875rem;
}
</style>
